export function checkIfPremium(userData) {
  if (!userData) return false;
  if (userData?.is_admin) return true;
  return (
    userData.stripe_customer_id &&
    (!userData.subscription_end ||
      new Date(userData.subscription_end) > new Date())
  );
}
